
<template>
<div>
<v-card  >
<v-toolbar   height="42"    color="#4A76A8" dark flat> <v-card-title>Добавить страницы</v-card-title> <v-spacer></v-spacer> <v-icon @click="close()">mdi-close</v-icon>  </v-toolbar>


<v-card-text>

  <v-layout  >
    <v-checkbox
    @click="useOnlyMine()"
    v-model="modals.useOnlyMine"
    label="Использовать только личные аккаунты"
    />

  <span style="color:green;font-size:1.2em">  {{ui.onlyMinePagesText}}  </span>
  </v-layout  >

<v-textarea v-if="!modals.useOnlyMine"  v-model="pgList" color="#4A76A8" box label="Список id страниц через запятую"> </v-textarea>




</v-card-text>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn @click="close()" small flat color="#4A76A8">Отменить</v-btn>  <v-btn :loading="loader"  @click="pagesAdd()" small color="#4A76A8"  class="white--text" > Добавить</v-btn>
</v-card-actions>
</v-card>
</div>
</template>

<script>

import axios from 'axios'
export default {
props:['modals','pages','ui' ],
  data () {
    return {
   loader : false,
   pgList : ""
    }
  },
methods: {
 close: function(){
   this.modals.addPages = false

 },
 pagesAdd: function(){

  this.loader = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_add.php', {
       method: 'POST',
       data: {
         list: this.pgList
       }
     })
     .then( response => {
        this.loader = false
        this.modals.addPages = false
        this.$store.dispatch('changeCounters')
     })

 },
},

}
</script>

<style   >

</style>
